import { getSupplierGenericProperties } from '@bridebook/web/app-basic/lib/analytics/helper';
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import {
  getInstagramMedia,
  getInstagramUrl,
  getSupplier,
  getSupplierTier,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  INSTAGRAM_MAX_ITEMS,
  InstagramGridItem,
} from '@bridebook/web/app-shared/components/supplier/sections/instagram-widget/instagram-grid-item';
import InstagramWidgetComp from '@bridebook/web/app-basic/components/supplier/sections/instagram-widget/instagram-widget';

export const InstagramWidget = () => {
  const isMobile = useSelector(getIsMobile);
  const supplier = useSelector(getSupplier);
  const instagramMedia = useSelector(getInstagramMedia);
  const instagramUrl = useSelector(getInstagramUrl);
  const maxPhotos = isMobile ? INSTAGRAM_MAX_ITEMS.mobile : INSTAGRAM_MAX_ITEMS.desktop;
  const dispatch = useDispatch();
  const supplierId = supplier?.id;
  const supplierTier = useSelector(getSupplierTier);
  const supplierGenericProps = getSupplierGenericProperties({ supplier, supplierTier });

  const onInstagramClick = useCallback(() => {
    dispatch(
      clickedOnLoggedOutPage({
        clickedLocation: 'supplierProfile',
        clickedSection: 'supplierSocialMediaGallery',
        cta: 'instagram',
        ...supplierGenericProps,
      }),
    );
  }, [dispatch, supplierGenericProps]);

  if (!supplierId || !instagramMedia?.length) return null;

  return (
    <InstagramWidgetComp
      instagramUrl={instagramUrl}
      photos={instagramMedia}
      maxPhotos={maxPhotos}
      isLoggedIn={false}
      onInstagramClick={onInstagramClick}
      renderGrid={(photos) =>
        photos.map((photo) => <InstagramGridItem photo={photo} key={photo.id} isLoggedIn={false} />)
      }
    />
  );
};
